import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  setPointMovements: ['payload'],
  setPointsEarnedForYear: ['payload'],
  setTiers: ['payload'],
  setPointBalance: ['payload'],
}, { prefix: '[LOYALTY_PROGRAM] ' });
